export default __webpack_public_path__ + "static/media/map-tile-developer.dc5c3d80.svg";